import PropTypes from 'prop-types';

// mantine
import { Stack, Divider, Text } from '@mantine/core';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { semanticColors } from 'theme';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item, opened }) => {
  // menu list collapse & items
  const items = item.children.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} opened={opened} />;
      default:
        return (
          <Text key={menu.id} c="red" ta="center" size="sm">
            Menu Items Error
          </Text>
        );
    }
  });

  return (
    <>
      <Stack gap={0}>
        {item.title && opened && (
          <Text
            size="xs"
            fw={500}
            c={semanticColors.text.muted}
            mb={4}
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {item.title}
            {item.caption && (
              <Text
                span
                size="xs"
                c={semanticColors.text.muted}
                style={{
                  display: 'block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {item.caption}
              </Text>
            )}
          </Text>
        )}
        {items}
      </Stack>

      {/* group divider */}
      <Divider my="xs" color={semanticColors.border.default} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
  opened: PropTypes.bool
};

export default NavGroup;
